import type { DataSyncDto } from "../../../common/model/dataSyncDto";

export class DataSync {
  constructor(
    public userId: string,
    public serviceName: string,
    public correlationId: string,
    public highWaterMark: number,
    public started: Date,
    public updated?: Date,
  ) {}

  static fromDto(u: DataSyncDto): DataSync {
    const { userId, serviceName, correlationId, highWaterMark, started, updated } = u;
    return new DataSync(userId, serviceName, correlationId, highWaterMark, started, updated);
  }
}
